import { render, staticRenderFns } from "./Fund-newAndCon.vue?vue&type=template&id=1fdd746a&scoped=true&"
import script from "./Fund-newAndCon.vue?vue&type=script&lang=js&"
export * from "./Fund-newAndCon.vue?vue&type=script&lang=js&"
import style0 from "./Fund-newAndCon.vue?vue&type=style&index=0&id=1fdd746a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdd746a",
  null
  
)

export default component.exports